import React, { useEffect, useState, useRef, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "./GamePage.css";
import {
  FaHome,
  FaGamepad,
  FaHeadphonesAlt,
  FaTrophy,
  FaTrailer,
} from "react-icons/fa";

export default function FullPage() {
  const navigate = useNavigate();
  const [allVideos, setAllVideos] = useState([]);
  const [visibleVideos, setVisibleVideos] = useState([]);
  const [page, setPage] = useState(1);
  const [loading, setLoading] = useState(false);
  const observer = useRef();

  const videosPerPage = 8;

  // Fetch semua video
  useEffect(() => {
    const fetchVideos = async () => {
      try {
        setLoading(true);
        const res = await fetch("https://api.backofficemain.com/list_video.php");
        const data = await res.json();

        // Format data agar ID YouTube bisa diambil dari link
        const formatted = data.map((v) => {
          let youtubeId = "";
          const link = v.videoLink || "";
          const match = link.match(/(?:v=|youtu\.be\/)([a-zA-Z0-9_-]{11})/);
          youtubeId = match ? match[1] : link;
          return { ...v, youtubeId };
        });

        setAllVideos(formatted);
        setVisibleVideos(formatted.slice(0, videosPerPage));
      } catch (error) {
        console.error("Failed to fetch videos:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchVideos();
  }, []);

  // Infinite scroll
  const lastVideoRef = useCallback(
    (node) => {
      if (loading) return;
      if (observer.current) observer.current.disconnect();

      observer.current = new IntersectionObserver((entries) => {
        if (entries[0].isIntersecting && visibleVideos.length < allVideos.length) {
          setPage((prevPage) => prevPage + 1);
        }
      });

      if (node) observer.current.observe(node);
    },
    [loading, visibleVideos, allVideos]
  );

  // Load next batch
  useEffect(() => {
    const next = allVideos.slice(0, page * videosPerPage);
    setVisibleVideos(next);
  }, [page, allVideos]);

  // Klik video => ke halaman viewvideo
  const handleCardClick = (video) => {
    navigate("/viewvideo", { state: video });
  };

  return (
    <div className="container py-4">
      {/* Top Menu */}
      <div className="d-flex justify-content-around text-center mb-4 menu-row">
        <div className="menu-btn" onClick={() => navigate("/")}>
          <FaHome className="menu-icon" />
          <span>Lobby</span>
        </div>
        <div className="menu-btn" onClick={() => navigate("/game")}>
          <FaGamepad className="menu-icon" />
          <span>Game</span>
        </div>
        <div className="menu-btn" onClick={() => navigate("/esport")}>
          <FaTrophy className="menu-icon" />
          <span>eSports</span>
        </div>
        <div className="menu-btn" onClick={() => navigate("/music")}>
          <FaHeadphonesAlt className="menu-icon" />
          <span>Music</span>
        </div>
        <div className="menu-btn active" onClick={() => navigate("/fullpage")}>
          <FaTrailer className="menu-icon" />
          <span>All</span>
        </div>
      </div>

      {/* Title */}
      <h2 className="text-danger fw-bold mb-3 text-center">All Videos</h2>

      {/* Video Grid */}
      <div className="row g-4">
        {visibleVideos.map((video, index) => {
          const isLast = index === visibleVideos.length - 1;
          return (
            <div
              key={video.id}
              className="col-6 col-md-4 col-lg-3"
              ref={isLast ? lastVideoRef : null}
            >
              <div
                className="card shadow-sm border-0 h-100 cursor-pointer"
                style={{ cursor: "pointer" }}
                onClick={() => handleCardClick(video)}
              >
                <img
                  src={`https://img.youtube.com/vi/${video.youtubeId}/0.jpg`}
                  className="card-img-top"
                  alt="Video Thumbnail"
                />
                <div className="card-body text-center">
                  <h6 className="fw-bold text-danger small mb-0">{video.title}</h6>
                </div>
              </div>
            </div>
          );
        })}
      </div>

      {/* Loading Indicator */}
      {loading && (
        <div className="text-center py-4">
          <div className="spinner-border text-danger" role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
        </div>
      )}
    </div>
  );
}
